import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class IosNativeBlockConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getOpenSiteInBrowserDeeplink(): string | undefined {
		return this.configService.get((x) => x.core.iosNativeBlock.websiteDeeplink, undefined);
	}
}
